import { Formik } from "formik";
import { memo } from "react";
import { Navigate } from "react-router-dom";

import { APP_ROUTES } from "const";
import validationSchema from "./VerifyOtp.schema";
import {
  useEmailFromLocation,
  useInitialState,
  useSubmitHandler,
} from "./VerifyOtp.hooks";
import VerifyOtpComponent from "./VerifyOtp.component";

function VerifyOtp() {
  const email = useEmailFromLocation();
  const initialState = useInitialState();
  const handleSubmit = useSubmitHandler(email);

  // If we don't know the email, the user landed here directly — send them back
  if (!email) {
    return <Navigate to={APP_ROUTES.SIGN_UP} replace />;
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialState}
      validationSchema={validationSchema()}
      onSubmit={handleSubmit}
    >
      <VerifyOtpComponent email={email} />
    </Formik>
  );
}

export default memo(VerifyOtp);
